import { render, staticRenderFns } from "./ReviewCardInfoItem.vue?vue&type=template&id=f1e2c2ee&scoped=true&"
import script from "./ReviewCardInfoItem.vue?vue&type=script&lang=js&"
export * from "./ReviewCardInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCardInfoItem.vue?vue&type=style&index=0&id=f1e2c2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e2c2ee",
  null
  
)

export default component.exports